export type PrProvider = "GitHub" | "GitLab" | "Bitbucket" | "AzureRepos"

export interface ParsedPr {
  provider: PrProvider | null
  label: string
}

const PROVIDER_PATTERNS: Record<PrProvider, RegExp> = {
  GitHub: /github\.com\/[^/]+\/[^/]+\/pull\/(\d+)/i,
  GitLab: /gitlab\.com\/[^/]+\/[^/]+\/-\/merge_requests\/(\d+)/i,
  Bitbucket: /bitbucket\.org\/[^/]+\/[^/]+\/pull-requests\/(\d+)/i,
  AzureRepos: /dev\.azure\.com\/[^/]+\/[^/]+\/_git\/[^/]+\/pullrequest\/(\d+)/i
}

export const parsePrUrl = (url: string): ParsedPr => {
  for (const [provider, pattern] of Object.entries(PROVIDER_PATTERNS)) {
    const match = url.match(pattern)
    if (match?.[1]) {
      return { provider: provider as PrProvider, label: `PR #${match[1]}` }
    }
  }

  const genericMatch = url.match(/\/(\d+)\/?$/)
  return {
    provider: null,
    label: genericMatch?.[1] ? `PR #${genericMatch[1]}` : "PR"
  }
}

export const getPrProviderFromUrl = (url: string): PrProvider | null => {
  if (url.includes("github.com")) return "GitHub"
  if (url.includes("gitlab.com")) return "GitLab"
  if (url.includes("bitbucket.org")) return "Bitbucket"
  if (url.includes("dev.azure.com")) return "AzureRepos"
  return null
}
